import { 
    ACTUALIZAR_LIST_LEGAJOS,
    AGREGAR_LEGAJO,
    MODIFICAR_LEGAJO,
  } from "./legajoActions";

  const CategoriasRRHHReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_LEGAJOS: {
            return {
                ...state,
                legajosList: action.payload
            }
        };

        case AGREGAR_LEGAJO:{
            return {
                 ...state,
                 legajosList: [action.payload, ...state.legajosList]
             }
         };

        case MODIFICAR_LEGAJO: {
            return {
                ...state,
                legajosList: state.legajosList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default: return state;
    }
  }

  export default CategoriasRRHHReducer;